import React, { useEffect, useState } from 'react';

import styles from './DogCardPupsPrized.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../Auth';
import { useAxios } from '../../../../../../AxiosHandler';
import DoughnutCard from '../../../../Statistics/Cards/DoughnutCard/DoughnutCard';

function DogCardPupsPrized(props: DogCardPupsPrizedProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [pupsPrizeData, setPupsPrizeData] = useState<any>();
    
    function getPupsPrizeData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/pups/prizes",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setPupsPrizeData(res.data);
            if (props.onDataLoaded != undefined) {
                props.onDataLoaded(res.data);
            }
        }).catch((err: any) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getPupsPrizeData();
        }
    }, [auth.selectedBreed]);

    return (
        <div className={styles.pupsprizedcard}>
            <DoughnutCard
                title={t("dog.statistics.areas.children.prized.title")}
                data={{
                    labels: [
                        t("dog.statistics.areas.children.prized.hasprize"),
                        t("dog.statistics.areas.children.prized.noprize"),
                    ],
                    datasets: [
                        {
                            backgroundColor: [
                                "#68db5a",
                                "lightgray",
                            ],
                            data: [
                                pupsPrizeData?.["PRIZED_OFFSPRING_COUNT"] ?? 0,
                                pupsPrizeData?.["ANTALL_AVKOM"] - (pupsPrizeData?.["PRIZED_OFFSPRING_COUNT"] ?? 0) ?? 0,
                            ],
                        },
                    ]
                }}
                overlay={<div className={styles.numberoverlay}>
                    {pupsPrizeData?.["PRIZED_OFFSPRING_COUNT"] ?? 0}/{pupsPrizeData?.["ANTALL_AVKOM"] ?? 0}
                </div>}
                options={{
                    cutout: "70%",
                }}
            ></DoughnutCard>
        </div>
    );
}

class DogCardPupsPrizedProps {
    dogId!: string | undefined;
    onDataLoaded?: (data: any) => void;
}

export default DogCardPupsPrized;